export interface IApplePayConfig {
  validationUrl: string;
  initiativeContext: string;
}

export const applePayConfig: IApplePayConfig = {
  validationUrl: `${
    process.env.APP_ENV === "dev" || process.env.APP_ENV === "local"
      ? "https://apple-pay-gateway-cert.apple.com/paymentservices/paymentSession"
      : "https://apple-pay-gateway.apple.com/paymentservices/paymentSession"
  }`,
  initiativeContext: `${
    process.env.APP_ENV === "prod"
      ? "dining.microsoft.com"
      : `${process.env.APP_ENV}.dining.microsoft.com`
  }`,
};
